import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialColumnHiddenState } from "./initializes";
import type { ColumnHidden } from "./types";

const columnHiddenSlice = createSlice({
  name: "ColumnHidden",
  initialState: initialColumnHiddenState,
  reducers: {
    setHiddenIndex: (state: ColumnHidden, action: PayloadAction<number[]>) => {
      state.hiddenIndex = action.payload;
    },
  },
});

export const { setHiddenIndex } = columnHiddenSlice.actions;

export default columnHiddenSlice.reducer;
